module.exports = __webpack_public_path__ + "static/img/WhyBorr_CompRates_1440x985a.40da1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/WhyBorr_CompRates_1440x985a.png
// module id = 1608
// module chunks = 5